import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import Nav from "@/components/Nav";
import ConsultDialog from "@/components/ConsultDialog";
import AccessGate from "@/components/AccessGate";
import ContentGuard from "@/components/ContentGuard";
import Home from "@/pages/Home";
import ComingSoon from "@/pages/ComingSoon";
import Miles from "@/pages/Miles";
import Unsubscribe from "@/pages/Unsubscribe";
import Terms from "@/pages/Terms";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function Layout({ children }) {
  const loc = useLocation();
  const hideNav = loc.pathname.startsWith("/admin");
  return (
    <>
      {!hideNav && <Nav />}
      {children}
    </>
  );
}

export default function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <Toaster position="top-center" />
        <ContentGuard />
        <AccessGate>
        <Layout>
          <ConsultDialog />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route
              path="/the-app"
              element={<ComingSoon eyebrow="Digital" title="The App." accent="Coming soon." line="Personalised support for barking, boredom, anxiety and more — in your pocket." path="/the-app" testid="the-app-page" />}
            />
            <Route
              path="/products"
              element={<ComingSoon eyebrow="Physical" title="Products." accent="Coming soon." line="Peace Chews and Off Duty — New Zealand-sourced natural treats, designed around calm." path="/products" testid="products-page" />}
            />
            <Route path="/miles" element={<Miles />} />
            {/* legacy redirects — keep old links working */}
            <Route path="/the-portfolio" element={<Home />} />
            <Route path="/for-businesses" element={<Home />} />
            <Route path="/for-dog-ppl" element={<Home />} />
            <Route path="/the-dog-files" element={<Home />} />
            <Route path="/the-miles" element={<Miles />} />
            <Route path="/about" element={<Miles />} />
            <Route path="/unsubscribe" element={<Unsubscribe />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
        </Layout>
        </AccessGate>
      </BrowserRouter>
    </HelmetProvider>
  );
}
